export const Terms = () => {
  return (
    <div className="min-h-screen">
      {/* Hero */}
      <section className="bg-navy-950 text-white py-20">
        <div className="max-w-7xl mx-auto px-6">
          <h1 className="text-4xl md:text-5xl font-bold">Terms of Use</h1>
        </div>
      </section>

      {/* Content */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-6">
          <div className="prose max-w-none">
            <p className="text-sm text-gray-500 mb-8">Last Updated: December 2024</p>

            <div className="space-y-8 text-gray-600 leading-relaxed">
              <div>
                <h2 className="text-2xl font-bold text-navy-900 mb-4">1. Acceptance of Terms</h2>
                <p>
                  By accessing and using this website, you accept and agree to be bound by these Terms of Use. If you do not agree to these terms, please do not use this website.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-navy-900 mb-4">2. Website Purpose</h2>
                <p>
                  This website is informational and intended for business partnership discussions only. It does not constitute an offer to sell products to consumers, provide consumer services, or create any binding agreements. All business partnerships require separate written agreements.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-navy-900 mb-4">3. No Consumer Transactions</h2>
                <p>
                  This website does not facilitate consumer purchases. Consumer transactions occur through authorized marketplace platforms (Amazon, Walmart, eBay, etc.), and those platforms' terms govern those transactions. This website provides business information only.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-navy-900 mb-4">4. Information Accuracy</h2>
                <p>
                  While we strive to provide accurate information, we make no warranties about the completeness, accuracy, or reliability of website content. Information may change without notice. Business partnerships require separate due diligence and written agreements.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-navy-900 mb-4">5. Intellectual Property</h2>
                <p>
                  All website content, including text, graphics, logos, and design, is the property of VERLINE or its licensors. Unauthorized use, reproduction, or distribution is prohibited. Brand names and trademarks mentioned belong to their respective owners.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-navy-900 mb-4">6. User Conduct</h2>
                <p className="mb-3">
                  When using our website, you agree not to:
                </p>
                <ul className="list-disc ml-6 space-y-2">
                  <li>Provide false or misleading information</li>
                  <li>Use the website for unlawful purposes</li>
                  <li>Attempt to gain unauthorized access to systems</li>
                  <li>Interfere with website functionality</li>
                  <li>Collect information about other users</li>
                </ul>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-navy-900 mb-4">7. Third-Party Links</h2>
                <p>
                  This website may contain links to third-party websites. We are not responsible for the content, accuracy, or practices of linked websites. Accessing third-party websites is at your own risk.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-navy-900 mb-4">8. Limitation of Liability</h2>
                <p>
                  To the fullest extent permitted by law, VERLINE shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of this website. Our total liability shall not exceed $100.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-navy-900 mb-4">9. Disclaimer of Warranties</h2>
                <p>
                  This website is provided "as is" without warranties of any kind, either express or implied. We disclaim all warranties including warranties of merchantability, fitness for a particular purpose, and non-infringement.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-navy-900 mb-4">10. Indemnification</h2>
                <p>
                  You agree to indemnify and hold VERLINE harmless from any claims, damages, losses, liabilities, and expenses arising from your use of this website or violation of these Terms of Use.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-navy-900 mb-4">11. Partnership Discussions</h2>
                <p>
                  Information submitted through contact forms does not create a partnership, agreement, or obligation. All business relationships require separate written agreements. Submission of inquiries does not guarantee response or partnership approval.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-navy-900 mb-4">12. Governing Law</h2>
                <p>
                  These Terms of Use are governed by the laws of the United States. Any disputes shall be resolved in courts located in the United States.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-navy-900 mb-4">13. Changes to Terms</h2>
                <p>
                  We reserve the right to modify these Terms of Use at any time. Changes will be posted on this page with an updated "Last Updated" date. Continued use of the website after changes constitutes acceptance of modified terms.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-navy-900 mb-4">14. Severability</h2>
                <p>
                  If any provision of these Terms of Use is found to be invalid or unenforceable, the remaining provisions shall remain in full force and effect.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-navy-900 mb-4">15. Contact Information</h2>
                <p>
                  For questions about these Terms of Use, contact us at partnerships@verline.com.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
